import { Link } from "@tanstack/react-router";
import { format, parseISO } from "date-fns";
import {
  GUIDE_CATEGORY_GRADIENTS,
  GUIDE_CATEGORY_LABELS,
  type GuideMeta,
} from "@/lib/guides";

export function GuideCard({ guide }: { guide: GuideMeta }) {
  return (
    <Link
      to="/guides/$slug"
      params={{ slug: guide.slug }}
      className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card shadow-sm transition-colors hover:border-foreground"
    >
      {guide.ogImage ? (
        <img src={guide.ogImage} alt="" className="h-40 w-full object-cover" />
      ) : (
        <div
          className={`flex h-40 w-full items-end p-4 ${GUIDE_CATEGORY_GRADIENTS[guide.category]}`}
          aria-hidden
        >
          <span className="text-sm font-semibold text-primary-foreground/90">
            {GUIDE_CATEGORY_LABELS[guide.category]}
          </span>
        </div>
      )}
      <div className="flex flex-1 flex-col p-6">
        <span className="w-fit rounded-full border border-border px-2.5 py-0.5 text-xs font-medium text-muted-foreground">
          {GUIDE_CATEGORY_LABELS[guide.category]}
        </span>
        <h2 className="mt-3 text-base font-semibold tracking-tight group-hover:text-accent">
          {guide.title}
        </h2>
        <p className="mt-1.5 flex-1 text-sm text-muted-foreground">{guide.description}</p>
        <p className="mt-4 text-xs text-muted-foreground">
          {format(parseISO(guide.publishDate), "MMM d, yyyy")} · {guide.readTime} min read
        </p>
        <span className="mt-3 text-sm font-medium">Read guide →</span>
      </div>
    </Link>
  );
}
